import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle'
import { RafflesFacade } from '@galabid/gb-dashboard/raffle/data-access'
import { NgSelectModule } from '@ng-select/ng-select'
import { TranslateModule } from '@ngx-translate/core'
import { ItemsEntity } from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.models'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { Observable } from 'rxjs'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'

@Component({
  selector: 'gb-presenter-tools-raffle-draw',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatInputModule,
    TranslateModule,
    NgSelectModule,
    GbDashboardSharedUiModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    GbPresenterToolsTextComponent,
  ],
  templateUrl: './gb-presenter-tools-raffle-draw.component.html',
  styleUrl: './gb-presenter-tools-raffle-draw.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsRaffleDrawComponent {
  @Input() toolsFormGroup!: FormGroup
  @Input() isTemplateMode: boolean = false

  @Output() preview = new EventEmitter<void>()
  @Output() resetPreview = new EventEmitter<void>()

  hideFields = ['font_family', 'font_style', 'font_weight', 'text_align']

  raffleItems$: Observable<ItemsEntity[]> = this.rafflesFacade.allRaffleItems$
  raffleItemsLoaded$ = this.rafflesFacade.loaded$

  get uuidControl(): FormControl {
    return this.toolsFormGroup.get('uuid') as FormControl
  }

  get raffleItemControl(): FormControl {
    return this.toolsFormGroup.get('raffle_item') as FormControl
  }

  get primaryColorControl(): FormControl {
    return this.toolsFormGroup.get('primary_color') as FormControl
  }

  get primaryTextColorControl(): FormControl {
    return this.toolsFormGroup.get('primary_text_color') as FormControl
  }

  get opacityControl(): FormControl {
    return this.toolsFormGroup.get('opacity') as FormControl
  }

  get enableConfettiControl(): FormControl {
    return this.toolsFormGroup.get('enable_confetti') as FormControl
  }

  get enableBulkRaffleDrawControl(): FormControl {
    return this.toolsFormGroup.get('enable_bulk_raffle_draw') as FormControl
  }

  get showPrizeNumbersControl(): FormControl {
    return this.toolsFormGroup.get('show_prize_numbers') as FormControl
  }

  get height(): FormControl {
    return this.toolsFormGroup.get('height') as FormControl
  }

  constructor(private rafflesFacade: RafflesFacade) {}

  setWidth(isBulk: MatSlideToggleChange) {
    const height = isBulk.checked ? 90 : 20
    this.height.setValue(height)
  }

  previewDraw(): void {
    this.preview.emit()
  }

  resetPreviewDraw(): void {
    this.resetPreview.emit()
  }

  compareItemsByUuid(a: ItemsEntity | null, b: ItemsEntity | null): boolean {
    return a?.uuid === b?.uuid
  }
}
